<template>
  <div v-if="show" class="FormColor" style="border-radius:0px;-webkit-box-shadow: 0 0 0 0 rgba(0, 0, 0, .08);box-shadow: 0 0 0 0 rgba(0, 0, 0, .08);">
    <el-form :model="formData" v-bind="option" :rules="formRules" label-width="100px" label-position="top">
      <slot name="formHeader"></slot>
      <div v-for="(item,key) in formInputs" :key="key" class="borders pad28 form-card">
        <slot name="formTips"></slot>
        <template v-if="item.card_type==11">
          <z-license-detail v-if="(item.status==1||item.status==2||item.status==6)" class="padd9" :input-data="formData" :input-card="item"></z-license-detail>
          <template v-else>
            <div class="FormTitle" v-if="item.title">
              <template v-if="!item.required">
                <div :class="localRequired[key]?'icon-radio icon-radiot':'icon-radio '" v-on:click="expandInputPanel(item,key)">
                  <i class="warm-icon el-icon-success"></i>
                </div>
                <div class="radio-right">{{ item.title }}</div>
              </template>
              <template v-else>{{ item.title }}</template>
              <z-license-status :exception="(item.status==3||item.status==4||item.status==5||item.status==7)" :reason="item.reason" :status="item.status"></z-license-status>
              <div class="clearfix"></div>
            </div>
            <div class="clearfix"></div>
            <div v-for="(inputCard,inputKey) in item.card_group" :key="inputKey" :ref="item.group_name" style="margin-bottom:15px">
              <template v-if="inputCard.show">
                <template v-if="inputCard.status != 2">
                  <!-- 可编辑 -->
                  <el-form-item v-if="( localRequired[key]) || item.required" :prop="inputKey">
                    <label v-if="![24,32].includes(inputCard.card_type)" slot="label" v-html="`${inputCard.label.content}${inputCard.label.icon_msg ? `(${inputCard.label.icon_msg})`:''}`">
                    </label>
                    <!-- <el-tooltip slot="label" effect="light" v-if="inputCard.label.icon">
                      <i :class="!inputCard.label.icon ? 'form-icon-color-gray':`${inputCard.label.icon} form-icon-color-gray`"/>
                      <div slot="content" class="form-labe-tip"><span>{{ inputCard.label.icon_msg }}</span></div>
                    </el-tooltip> -->
                    <el-input v-if="inputCard.card_type==19" :ref="inputKey" :type="inputCard.input_type" :placeholder="inputCard.options.placeholder?inputCard.options.placeholder:'请输入'+inputCard.label.content" v-model="formData[inputKey]" :name="inputKey" v-bind="inputCard.options"></el-input>
                    <el-input v-if="inputCard.card_type==20" :ref="inputKey" :type="inputCard.input_type" v-model="(formData[inputKey])" :name="inputKey" :rows="3" v-bind="inputCard.options"></el-input>
                    <el-select v-if="inputCard.card_type==22" :placeholder="inputCard.options.placeholder?inputCard.options.placeholder:'请输入'+inputCard.label.content" :ref="inputKey" v-model="formData[inputKey]" :name="inputKey" v-bind="inputCard.options">
                      <el-option v-for="option_item in inputCard.items" :key="option_item.value" :label="option_item.label" :value="option_item.value"></el-option>
                    </el-select>
                    <div v-if="inputCard.card_type==21">
                      <el-cascader v-if="inputCard.items" :ref="inputKey" :placeholder="inputCard.options.placeholder?inputCard.options.placeholder:'请输入'+inputCard.label.content" @change="$emit('cascader_change',$event,inputCard)" v-model="formData[inputKey]" :name="inputKey" v-bind="inputCard.options" :options="inputCard.items">
                      </el-cascader>
                      <slot name="cascaderContent"></slot>
                    </div>
                    <div v-if="inputCard.card_type==24" class="radio-group-top" :ref="inputKey">
                      <!--  <el-radio-group :ref="inputKey" :value="formData[inputKey]" :placeholder="inputCard.options.placeholder?inputCard.options.placeholder:'请输入'+inputCard.label.content" class="radio-group-top" v-model="formData[inputKey]" :name="inputKey" v-bind="inputCard.options" @change="radioChanage($event,inputCard)">
                        <el-radio v-for="radio_item in inputCard.items" :key="radio_item.value" :label="radio_item.value">{{ radio_item.label }}
                        </el-radio>
                      </el-radio-group> -->
                      <el-radio v-model="formData[inputKey]" v-for="radio_item  in inputCard.items" :key="radio_item.value" @change="radioChanage($event,inputCard)" :label="radio_item.value">{{ radio_item.label }}
                      </el-radio>
                    </div>
                    <template  v-if="inputCard.card_type==25">
                      <el-date-picker :placeholder="inputCard.options.placeholder?inputCard.options.placeholder:'请输入'+inputCard.label.content" :ref="inputKey" v-model="formData[inputKey]" :picker-options="pickerOptions0" value-format="yyyy-MM-dd" :name="inputKey" v-bind="inputCard.options" @change="value => datepickerChange(value, inputKey)">
                      </el-date-picker>
                      <el-checkbox style="margin-left:10px" v-model="formData[inputKey + 'checkFlag']" @change="value => datepickerFlagChange(value, inputKey)">仅当天有效</el-checkbox>
                    </template>
                    <div v-if="inputCard.card_type==26" class="upload-input" style="margin-top: 0px;height:240px; ">
                      <z-upload :file-list="formData[inputKey]" :ref="inputKey" v-on:validate-upload="validField" :options="inputCard.options" :name="inputKey" :input-key="inputKey" drag :input-card="inputCard"></z-upload>
                      <div class="downloadxy" v-html="inputCard.remark"></div>
                    </div>
                    <div v-if="inputCard.card_type==27" class="upload-input" style="margin-top: 0px;height:240px; ">
                      <z-upload-big :file-list="formData[inputKey]" :ref="inputKey" v-on:validate-upload="validField" :options="inputCard.options" :name="inputKey" :input-key="inputKey" :input-card="inputCard"></z-upload-big>
                      <div class="downloadxy" v-html="inputCard.remark"></div>
                    </div>
                    <div v-if="inputCard.card_type==29">
                      <z-record-number :value="formData[inputKey]" :ref="inputKey" @change="changeData" :name="inputKey" :input-key="inputKey" :input-card="inputCard"></z-record-number>
                    </div>
                    <el-input v-if="inputCard.card_type==28" type="number" :ref="inputKey" :placeholder="inputCard.options.placeholder?inputCard.options.placeholder:'请输入'+inputCard.label.content" v-model="formData[inputKey]" :name="inputKey" v-bind="inputCard.options"></el-input>
                    <div v-if="inputCard.card_type==30">
                      <z-complex-text :value="formData[inputKey]" :ref="inputKey" @change="changeData" :options="inputCard.options" :name="inputKey" :input-key="inputKey" :input-card="inputCard"></z-complex-text>
                    </div>
                    <div v-if="inputCard.card_type>30">
                      <z-others :value="formData[inputKey]" :ref="inputKey" @change="changeData" :options="inputCard.options" :name="inputKey" :input-key="inputKey" :input-card="inputCard"></z-others>
                    </div>
                    <div class="clearfix"></div>
                  </el-form-item>
                  </template>
                <template v-else>
                  <!-- 不可编辑 -->
                  <!-- 不可编辑且没有值时不显示 -->
                  <template v-if="!formData[inputKey]">
                  </template>
                  <template v-else-if="inputCard.card_type==26">
                    <p v-html="inputCard.label.content + '：'"></p>
                    <div class="img-g280 left-left borgaryg" v-for="(img,imgkey) in formData[inputKey]" :key="imgkey">
                      <a class="zoom zoom-in" @click="HandlePreview(img.url)">
                        <div v-if="!img.url.toLocaleLowerCase().includes('.pdf')" class="imgupload" :style="{backgroundImage: 'url(' + img.url + ')' }"></div>
                        <div v-else class="imguploadPdf"></div>
                      </a>
                    </div>
                    <div class="clearfix"></div>
                  </template>
                  <template v-else-if="inputCard.card_type==27">
                    <p v-html="inputCard.label.content + '：'"></p>
                    <div class="left-left borgaryg" v-for="(video,videokey) in formData[inputKey]" :key="videokey">
                      <video class="imgupload" controls="controls" :src="video.url" autoplay></video>
                    </div>
                    <div class="clearfix"></div>
                  </template>
                  <el-form-item v-else-if="[29,30,31,32].includes(inputCard.card_type)" :prop="inputKey">
                    <div v-if="inputCard.card_type==29">
                      <z-record-number :disabled="true" :value="formData[inputKey]" :ref="inputKey" @change="changeData" :name="inputKey" :input-key="inputKey" :input-card="inputCard" ></z-record-number>
                    </div>
                    <div v-else-if="inputCard.card_type==30">
                      <z-complex-text :disabled="true" :value="formData[inputKey]" :ref="inputKey" @change="changeData" :options="inputCard.options" :name="inputKey" :input-key="inputKey" :input-card="inputCard"></z-complex-text>
                    </div>
                    <div v-else-if="inputCard.card_type>30">
                      <z-others :disabled="true" :value="formData[inputKey]" :ref="inputKey" @change="changeData" :options="inputCard.options" :name="inputKey" :input-key="inputKey" :input-card="inputCard"></z-others>
                    </div>
                  </el-form-item>
                  <!-- <template v-else-if="inputCard.card_type==32">
                    <div style="line-height: 40px;font-size: 14px; color: #596597;">
                      <span>请勾选同意<a :href="formData[inputKey]">{{inputCard.label.content}}</a>：<span class="license-value">已勾选</span></span>
                    </div>
                    <div class="clearfix"></div>
                  </template> -->
                  <template v-else>
                    <div style="line-height: 40px;font-size: 14px; color: #596597;">
                      <span v-html="inputCard.label.content + '：'"></span><span class="license-value">{{ formatterValue(formData[inputKey]) }}</span>
                    </div>
                  </template>
                  </template>
                </template>
            </div>
          </template>
        </template>
      </div>
      <slot name="formFooter"></slot>
    </el-form>
    <z-layer ref="layer" :visible.sync="dialogVisible">
      <div class="imgbigover" :style="{backgroundImage: 'url(' + dialogImageUrl + ')' }">
        <!--<img width="730 " height="530 " :src="dialogImageUrl " alt=" ">-->
      </div>
      <!--<img width="730" height="530" :src="dialogImageUrl" alt="">-->
    </z-layer>
  </div>
</template>
<script>
import Upload from '@/components/form/Upload'
import UploadBig from '@/components/form/SimpleUploader'
import RecordNumber from '@/components/form/RecordNumber'
import ComplexText from '@/components/form/ComplexText'
import Others from '@/components/form/Others'
import LicenseDetail from '@/components/detail/LicenseDetail'
import moment from 'moment'
import qs from 'qs'
import { getData } from "@/utils/utils";

const today = moment().format('YYYY-MM-DD')
// 备案号校验
const validateRecordNumber = (info, rule, value, callback) => {
  // console.log(info,value)
  let needCheck = info.required==1//必填
  const hasType = value && ['0', '1'].includes(String(value.recordType))
  let hasText = !!(value&&value.recordText)
  if (hasText) { 
    const arr = value.recordText.split('###')
    hasText = arr.some(t=>!!t.trim())
  }

  if (!needCheck&&(hasType||hasText)) {
    needCheck = true
  }
  
  if (needCheck) {
    if (!hasType) {
      callback(new Error('请选择备案号类型'));
    }
    const arr = value.recordText.split('###')
    if (arr.length < 3 || !arr[0] || !arr[1] || !arr[2]) {
      callback(new Error('请填写完整备案号信息'));
    }
    
  }
  callback()
};
// 复杂文本校验
const validateComplex = (info, rule, value, callback) => {
  // console.log(info,value)
  let needCheck = info.required==1//必填
  let hasText = value&&value.some(arr=>arr.some(v=>!!v.trim()))//输入框有内容
  if (!needCheck&&hasText) {
    needCheck = true
  }
  if (needCheck) {
    if (value && value.length == 0) {
      callback(new Error('请填写'+info.content));
    }
    value.forEach(arr => {
      let flag = arr.some((str, i) => {
        return (!str && !arr[i + 1] && str == arr[i + 1])||(arr.length==1&&!arr[0])
      })
      if (flag) callback(new Error('请填写'+info.content+'的完整信息'));
    })
  }
  callback()
};
// 下拉框校验
const validateSelect = (info,rule, value, callback) => {
  // console.log(JSON.stringify(value))
  let needCheck = info.required == 1//必填
  if (needCheck&&value.first.length<=0) {
    callback(new Error('请选择'+info.content +'一级'));
  }
  if (!needCheck&&value.first.length>0) {
    needCheck=true
  }
  if (needCheck&&value.second&&(value.second.length<=0||!value.second[0])) {
    callback(new Error('请选择'+info.content +'二级'));
  }
  callback()
};
// 协议校验
const validateContract = (info, rule, value, callback) => {
  // console.log(info,value)
  if (value!='true'&&info.required==1) {
    callback(new Error('请勾选'+info.content));
  } else{
    callback()
  }
  
};
const validatePass = {
  29:validateRecordNumber,
  30:validateComplex,
  31:validateSelect,
  32:validateContract,
}
const needTrans=[29,30,31]
export default {
  name: 'form-card',
  props: {
    formData: {
      type: Object,
      default: () => {}
    },
    formInputs: {
      type: Array,
      default: () => []
    },
    formRules: {
      type: Object,
      default: () => {}
    },
    options: {
      type: Object,
      default: () => {}
    },
    id: String,
    name: String,
    isCopy: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      option: {},
      dialogVisible: false,
      dialogImageUrl: '',
      show_required: false,
      localRequired: {},
      cascaderContent: {},
      localGroupName: {},
      show: true,
      pickerOptions0: {
        disabledDate: function (time) {
          return time.getTime() < Date.now() - 60*24*60*1000
        }
      },
      allFields:{},
      hasHandle:false,//初次处理JSON字段
      moment
    }
  },
  watch: {
    cardData: function (newData, oldData) {},
    localRequired: function (newVal, oldVal) {},
    formData: {
      handler(newVal, oldVal) {
        this.jsonToObject()
      },
      immediate:true
    },
    formInputs: {
      handler(newVal, oldVal) {
        this.jsonToObject()
      },
      immediate:true
    },
  },
  components: {
    'z-upload': Upload,
    'z-upload-big': UploadBig,
    'z-license-detail': LicenseDetail,
    'z-record-number': RecordNumber,
    'z-complex-text': ComplexText,
    'z-others': Others,
  },
  mounted: function () {
    this.cascaderContent = this.$slots.cascaderContent
    this.option = Object.assign({ id: this.id, name: this.name }, this.options)
    this.$on('validate', () => {
      this.validateForm()
    })
    for (let item in this.formInputs) {
      let inputCards = this.formInputs[item]
      for (let key in inputCards.card_group) {
        let inputCard = inputCards.card_group[key]
        if (inputCard.status === 1) {
          this.$set(this.formInputs[item].card_group[key], 'disabled', true)
        }
        if (inputCard.card_type === 21) {
          this.$emit('cascader_change', this.formData[key], inputCard)
        }
        if (inputCard.card_type === 25) {
          this.$set(this.formData, [key + 'checkFlag'], this.formData[key] == today)
        }
      }
    }
  },
  methods: {
    datepickerChange(value, inputKey){
      this.formData[inputKey+'checkFlag'] = value == today
    },
    datepickerFlagChange(value, inputKey){
      this.formData[inputKey] = value ? today : this.formData[inputKey]
    },
    jsonToObject() {
      if (!this.hasHandle&&this.formData&&this.formInputs) {
        let fields = {} 
        this.formInputs.forEach(item=>{
          fields = {
            ...fields,
            ...item.card_group
          }
        })
        Object.keys(this.formData).map((key) => { //下拉框，复杂文本，备案号 
          if (fields[key] && needTrans.includes(fields[key].card_type)&&this.formData[key]&& typeof(this.formData[key])=='string') { 
            try{
              const obj = JSON.parse(this.formData[key])
              this.formData[key] = obj
            } catch (err){
              console.error('转化json出错',err)
            }
          }
        })
        this.allFields=fields
        this.hasHandle = true
      }
      
    },
    validateForm: function () {
      this.$refs[this.options.ref].validate((valid) => {
        if (!valid) {
          this.$message.warning('请填写必填项')
        }
        //处理字段值是对象的情况
        const formData = JSON.parse(JSON.stringify(this.formData))
        Object.keys(formData).map((key) => { //下拉框，复杂文本，备案号 需要转JSON
          if (this.allFields[key] && needTrans.includes(this.allFields[key].card_type) && formData[key]) { 
            //判断选填值 为空的情况，去掉该字段
            if (
              (this.allFields[key].card_type == 30 && formData[key].every(arr => arr.every(v => !v.trim()))) || //复杂文本为空的情况
              (this.allFields[key].card_type == 31 && formData[key].first.length<=0)|| //下拉框为空的情况
              (this.allFields[key].card_type == 29 && !formData[key].recordType&&formData[key].recordText.length<=0) //备案号为空的情况
            ) {
              delete formData[key]
            } else {
              formData[key] = JSON.stringify(formData[key])
            }
            
            // console.log('formData[key]',key,formData[key])
          }
        })
        this.$emit('formEvent', { valid: valid, data: formData })
      })
    },
    validField: function (prop, callback) {
      this.$refs[this.options.ref].validateField(prop, (valid) => {
        callback && callback(valid)
      })
    },
    changeData({key,value}) {
      this.$set(this.formData, key, value)
      this.validField(key)
    },
    expandInputPanel: function (item, key) {
      if(item.disable){
        return;
      }
      if (this.localRequired[key]) {
        this.$set(this.localRequired, key, !this.localRequired[key])
      } else {
        this.$set(this.localRequired, key, true)
      }
      if (this.localRequired[key] === false) {
        let inputCards = this.formInputs[key]
        for (let inputKey in inputCards.card_group) {
          if (this.formData[inputKey] instanceof Array) {
            this.formData[inputKey] = []
          } else {
            delete (this.formData[inputKey])
            if (inputCards.card_group[inputKey].card_type === 24) {
              this.radioChanage(this.formData[inputKey], inputCards.card_group[inputKey])
            }
          }
        }
      }
    },
    HandlePreview: function(image) {
      if (image && !image.toLocaleLowerCase().includes(".pdf")) {
        this.dialogVisible = true;
        this.dialogImageUrl = image;
      }
      if (image && image.toLocaleLowerCase().includes(".pdf")) {
        let data = qs.parse(image.split("?")[1]);
        if(data && data.Expires){
          // 失效时间
          if(new Date().getTime() > String(data.Expires).padEnd(13,'0')){
            getData("/api/file/ssig/update", { url: image }, res => {
                if (res.code == 0) {
                  window.open(res.data,'_blank')
                } else {
                  window.location.reload()
                }
            },error => window.location.reload());
          }else {
            window.open(image,'_blank')
          }
        }else {
          window.open(image,'_blank')
        }
      }
    },
    radioChanage: function (value, input) {
      value = parseInt(value)
      for (let item in this.formInputs) {
        let inputCards = this.formInputs[item]
        for (let key in inputCards.card_group) {
          let inputCard = inputCards.card_group[key]
          if (inputCard.group_name === input.group_name) {
            inputCard.show = false
            input.show = true
            if (inputCard.item_id === value) {
              inputCard.show = true
            }
          }
        }
      }
    },
    formatterValue: function(value) {
      if (isNaN(value)) {
        return value;
      }
      //处理不需要转换的数字
      var str = "" + value;
      if (!/e/i.test(str)) {
        return value;
      }
      return value
        .toFixed(18)
        .replace(/\.0+$/, "")
        .replace(/(\.\d+[1-9])0+$/, "$1");
    },
  },
  created: function () {
    for (let item in this.formInputs) {
      let inputCards = this.formInputs[item]
      for (let key in inputCards.card_group) {
        let inputCard = inputCards.card_group[key]
        if (inputCard.status === 1 || inputCard.status === 2) {
          inputCard.options.disabled = true
        }
        if (inputCards.required === false && (inputCards.status === 3 || inputCards.status === 4 || inputCards.status === 5 || inputCards.status === 7)) {
          this.$set(this.localRequired, item, true)
        } else if (inputCards.required === false && inputCards.status === 0) {
          if (!this.isCopy && !Array.isArray(this.formData[key])) {
            delete (this.formData[key])
          }
        }
        if (inputCard.card_type === 24 && this.formData[key]) {
          this.radioChanage(this.formData[key], inputCard)
        }
        if (inputCard.card_type === 26 && typeof (this.formData[key]) === 'string' && this.formData[key] === '') {
          this.formData[key] = []
        }
        if (inputCard.card_type > 28) {//自定义 复杂类型的验证规则 this.formRules[key][0].required == 1 必填
          //必填时 校验是否有值 和 值的完整性
          //选填时 若有值 需要校验完整性
          const info = { ...inputCard.label,...this.formRules[key][0] }
          const trigger =inputCard.card_type == 32?'change':'blur'
          this.$set(this.formRules[key], 1, { validator: validatePass[inputCard.card_type].bind(this,info) ,trigger})
        }
      }
    }
    for (let key in this.formData) {
      if (typeof this.formData[key] === 'number') {
        // 字段值如果为纯数字，会自动转为number 需要强制转换string
        this.formData[key] = this.formData[key].toString()
      }
    }
  }
}

</script>
<style>
.is-error .el-upload {
  border: 1px solid #f56c6c;
  border-color: #f56c6c;
}

.FormColor label {
  color: #596597;
}

.FormTitle {
  font-size: 18px;
  color: #2E334A;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: -3px;
}

.FormTitle {
  font-size: 18px;
  color: #2E334A;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: -3px;
}

.form-labe-tip {
  font-size: 12px;
  color: #2E334A;
  letter-spacing: 0.1px;
  line-height: 20px;
  text-align: left;
  max-width: 364px;
  min-width: 250px;
  min-height: 30px;
}

.form-labe-tip span {
  padding: 20px 5px 0 10px;
}

.el-form-item.is-required .el-form-item__label:before {
  content: '';
  color: #ffffff;
  margin-right: 0px
}

.el-form-item.is-required .el-form-item__label:after {
  content: "*";
  color: #C82439;
  margin-left: 4px;
  position: relative;
  top: 3px;
}

.icon-upload {
  font-size: 40px;
}

.icon-circle-message {
  background: #A5ABC6;
  width: 12px;
  height: 12px;
  -moz-border-radius: 50px;
  -webkit-border-radius: 50px;
  border-radius: 50%;
  text-align: center;
  color: #FFFFFF;
}

.item-tooltip {
  float: left;
}

.default-error input {
  border-color: #f56c6c;
}

.form-icon-color-gray {
  position: relative;
  top: 0px;
  font-size: 12px;
  color: #A5ABC6;
}

.pad28 {
  padding: 6px 30px 30px;
}

.form-card .el-form-item__label {
  padding: 0 !important;
  margin-bottom: -7px;
}

.pad28 {
  padding: 6px 30px 30px;
}

.form-card .el-form-item__label {
  padding: 0 !important;
  margin-bottom: -7px;
}

.form-card .el-form-item {
  margin-bottom: -4px !important;
}

.form-card .el-form-item__error {
  color: #c82439 !important;
}

.pad28 input,
textarea {
  width: 460px;
  border: 1px solid #E1E6F1 !important;
}

.pad28 input:focus {
  border: 1px solid #2A60E4 !important;
}

.pad28 textarea:focus {
  border: 1px solid #2A60E4 !important;
}

.form-card .el-form-item {
  margin-bottom: -4px !important;
}

.form-card .el-form-item__error {
  color: #c82439 !important
}

.icon-radio {
  width: 20px;
  height: 20px;
  border-radius: 100px;
  border: 1px solid #E1E6F1;
  float: left;
  margin-top: 2px;
  position: relative
}

.pad28 input,
textarea {
  width: 460px;
  border: 1px solid #E1E6F1 !important;
  font-family: "PingFangSC-Medium", "Microsoft YaHei", "微软雅黑", Arial, sans-serif !important;
}

.pad28 input[type="number"]::-webkit-inner-spin-button,
.pad28 input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.pad28 input:focus {
  border: 1px solid #2A60E4 !important;
}

.pad28 textarea:focus {
  border: 1px solid #2A60E4 !important;
}

.pad28 .el-date-editor input {
  width: 220px;
}

.icon-radio {
  width: 20px;
  height: 20px;
  border-radius: 100px;
  border: 1px solid #E1E6F1;
  float: left;
  margin-top: 2px;
  position: relative
}

.icon-radio i {
  display: none
}

.icon-radiot {
  border: none
}

.icon-radiot i {
  color: #2A60E4;
  font-size: 22px;
  float: left;
  display: block;
  left: 0;
  top: 0px;
  position: absolute;
  z-index: 8;
}
.radio-group-top{ margin-top: 25px;}
.radio-group-top .w-radio_wrapper_3h9Mq {
  display: block;
  margin-bottom: 25px;
  font-size: 14px;
}

.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  visibility: hidden;
  clear: both;
}

.radio-right {
  margin-left: 10px;
  margin-right: 10px;
  float: left;
}

.radio-right .icon-color-red[data-v-391d513a] {
  font-size: 12px;
  color: #ce3b4f;
  margin-left: 5px;
}

.downloadxy {
  position: absolute;
  top: 96%;
  width: 100%;
  font-size: 14px;
  color: #2A60E4
}

.downloadxy a {
  color: #2A60E4;
  text-decoration: none
}

.radio-group-top .w-radio_wrapper_3h9Mq {
  display: block;
  margin-bottom: 25px;
  font-size: 14px;
}

.radio-group-top .el-radio {
  margin-left: 0;
  width: 100%;
  height: 40px;
}

/* .el-form-item__label {
  margin-top: 10px;
} */

.el-form-item__content textarea {
  width: 460px;
}

.form-card {
  margin-bottom: 20px;
  padding-bottom: 40px;
  border-radius: 4px;
  -webkit-box-shadow: 0 2px 10px 0 rgba(0, 0, 0, .08);
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, .08);
  position: relative;
}
.img-g280 {
  margin-top: 5px;
  width: 280px;
  height: 210px;
  margin-right: 20px;
  position: relative;
}

.imgupload {
  width: 280px;
  height: 210px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
}

.imguploadPdf {
  width: 280px;
  height: 210px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 50%;
  background-color: #f9fafd;
  background-image: url('../../assets/PDF.png');
}

.imgbigover {
  width: 750px;
  max-height: 530px;
  overflow: hidden;
  margin: 0;
  padding-bottom: 90%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
.form-card {
  margin-bottom: 20px;
  padding-bottom: 40px;
  border-radius: 4px;
  -webkit-box-shadow: 0 2px 10px 0 rgba(0, 0, 0, .08);
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, .08);
}
.form-status-7{
  padding-top: 18px;
}
.left-left {
  float: left;
}
.license-value{
  max-width: 1060px;
  display: inline-block;
  word-wrap: break-word;
  word-break: break-word;
  vertical-align: top;
}
.el-checkbox__label{
  padding-left: 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/form/Form.vue